export const SET_EMPRESAS = 'SET_EMPRESAS';
export const LOADING_EMPRESAS = 'LOADING_EMPRESAS';
